<template>
  <router-view />
  <div class="citySelectWebApp" v-if="isShowCityWebApp">
    <div class="selectCityBlock">
      <div class="selectCityBlockHead">
        <p>Выберите город для продолжения</p>
      </div>
      <div class="selectCityBlockBody">
        <input
          class="selectCityInput"
          @focusin="isShowCityWebAppList = true"
          v-model="selectedCity"
        />
        <div class="cityList" v-show="isShowCityWebAppList">
          <p>Города России</p>
          <ul>
            <!-- prettier-ignore -->
            <li
              v-for="city in cityList.filter(city => city.toLowerCase().includes(selectedCity.toLowerCase()))"
              v-bind:key="city"
              @click="
                selectedCity = city; isShowCityWebAppList = false
              "
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="14" height="14" rx="3" fill="#F3F3F3" />
              </svg>
              {{ city }}
            </li>
          </ul>
        </div>
      </div>
      <button class="reservationButton" @click="setCity">Выбрать</button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { io } from "socket.io-client";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      isShowCityWebApp: false,
      isShowCityWebAppList: false,
      selectedCity: "",
      socket: null,
    };
  },
  methods: {
    initChatWidget(fullscreen = false) {
      const urlId = new URLSearchParams(window.location.search).get("id");
      if (urlId) sessionStorage.setItem("chatWidgetId", urlId);
      const widgetId = urlId || sessionStorage.getItem("chatWidgetId") || "";
      const isSupport = window.location.pathname === "/support";
      window.ChatWidget?.init({
        theme: "white",
        apiUrl: "https://xtechsupport.info",
        wsUrl: "wss://xtechsupport.info",
        initMessage: "Здравствуйте, чем мы можем Вам помочь?",
        primaryColor: "#FF8989",
        ...(fullscreen ? { fullscreen: true } : {}),
        header: {
          headline: "Техническая поддержка",
          message: "Операторы онлайн!",
        },
        meta: {
          userId: isSupport
            ? widgetId
            : this.$store.getters.getUserData
            ? this.$store.getters.getUserData._id
            : "",
          botId: "-101",
          type: "ESCORT",
          username: isSupport
            ? widgetId
            : this.$store.getters.getUserData
            ? this.$store.getters.getUserData.login
            : "",
          numId: this.$store.getters.getUserData ? this.$store.getters.getUserData.numId : "",
        },
      });
    },
    loadChatWidget() {
      if (this._widgetLoading) return;
      const isSupport = window.location.pathname === "/support";
      this.unloadChatWidget();
      this._widgetLoading = true;
      const script = document.createElement("script");
      script.src = "https://cdn.xtechsupport.info/dist/chat-widget.js";
      script.onload = () => {
        this._widgetLoading = false;
        this.initChatWidget(isSupport);
        console.log(isSupport);
      };
      document.head.appendChild(script);
    },
    unloadChatWidget() {
      this._widgetLoading = false;
      window.ChatWidget?.close?.();
      const script = document.querySelector('script[src*="chat-widget"]');
      if (script) script.remove();
      document
        .querySelectorAll("#chat-widget-container, [id^='chat-widget'], [class*='chat-widget']")
        .forEach((el) => el.remove());
      window.ChatWidget = undefined;
    },
    async setCity() {
      try {
        const res = await axios.put(
          `https://${process.env.VUE_APP_SERVERHOST}/api/users/city`,
          {
            cityName: this.selectedCity,
          },
          {
            headers: {
              authorization: `Bearer ${this.$store.getters.getUserData.token}`,
            },
          },
        );
        console.log("ГОРОД СМЕНИЛИ", res);
        const findCity = this.$store.getters.getCityList.find(
          (item) => item === res.data.result.cityId.name,
        );
        this.$store.commit("setCity", findCity);
        this.loginUser(this.$store.getters.getUserData.token);
      } catch (e) {
        console.error("Error setting city:", e);
      }
    },
    async loginUser(token) {
      try {
        const res = await axios.post(
          `https://${process.env.VUE_APP_SERVERHOST}/api/auth/anon/login`,
          {
            token,
          },
        );
        this.$store.commit("setUserData", res.data.result);
        window.location.reload();
        if (!res.data.result.cityId) {
          // await this.setCity();
          this.isShowCityWebApp = true;
        }
        // this.setCity();
        console.log(res);
      } catch (e) {
        console.error("Error fetching user data:", e);
      }
    },
    handleSocketNotification(payload) {
      console.log("Socket notification:", payload);

      const message = payload?.data?.message;
      if (message) {
        this.toast.info(message, { timeout: 4000 });
      }

      window.dispatchEvent(
        new CustomEvent("escort:notification", {
          detail: payload,
        }),
      );
    },
    disconnectSocket() {
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
    },
    connectToSocket() {
      const token = this.$store.getters.getUserData?.token;
      if (!token) return;

      this.disconnectSocket();

      this.socket = io(`https://socket.${process.env.VUE_APP_SERVERHOST}`, {
        transports: ["websocket", "polling"],
        auth: {
          token,
        },
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
      });

      this.socket.on("connect", () => {
        console.log("Connected to socket");
      });

      this.socket.on("disconnect", (reason) => {
        console.log("Disconnected from socket:", reason);
      });

      this.socket.on("connect_error", (error) => {
        console.error("Error connecting to socket:", error);
      });

      this.socket.on("NOTIFICATION", (payload) => {
        this.handleSocketNotification(payload);
      });
    },
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  computed: {
    cityList() {
      return this.$store.getters.getCityList;
    },
  },
  watch: {
    "$store.getters.getUserData"(newVal) {
      if (newVal) {
        this.loadChatWidget();
      } else {
        this.unloadChatWidget();
      }
    },
    "$route.path"(newPath, oldPath) {
      if (!this.$store.getters.getUserData) return;
      if (newPath !== oldPath) {
        this.loadChatWidget();
      }
    },
  },
  async mounted() {
    const token = new URLSearchParams(window.location.search).get("token");
    if (token && this.$store.getters.getUserData === null) {
      this.loginUser(token);
    }
    if (this.$store.getters.getUserData) {
      this.connectToSocket();
      this.loadChatWidget();
    } else if (new URLSearchParams(window.location.search).get("id")) {
      this.loadChatWidget();
    }
    if (this.$store.getters.getUserData && !this.$store.getters.getUserData.cityId) {
      this.isShowCityWebApp = true;
    }
    document.addEventListener("click", (event) => {
      const cityInput = document.querySelector(".selectCityInput");
      const cityList = document.querySelector(".cityList");
      if (!cityInput || !cityList) return;
      if (!cityInput.contains(event.target) && !cityList.contains(event.target)) {
        this.isShowCityWebAppList = false;
      }
    });
  },
  beforeUnmount() {
    this.disconnectSocket();
  },
};
</script>
<style>
#app {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2f2f2f;
  background-color: #ffffff;
}

nav {
  padding: 30px;
}
* {
  margin: 0;
  box-sizing: border-box;
  font-family: "Open Sans";
  font-size: 16px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  scroll-behavior: smooth;
  scrollbar-color: #000000 #ffffff;
  scrollbar-width: thin;
}
a {
  text-decoration: none;
}
html {
  scroll-behavior: smooth;
  scrollbar-color: #000000 #ffffff;
  scrollbar-width: thin;
  overflow-y: scroll;
  overflow: overlay;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}
nav a.router-link-exact-active {
  color: #42b983;
}
body {
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-active {
  opacity: 0;
}
.loading {
  display: flex;
  justify-content: center;
  width: 30%;
  height: 30%;
  margin: 0 auto;
}
.flicking-pagination {
  bottom: 10px;
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: 2;
}
.flicking-pagination-bullet {
  background-color: #0a0a0a1a;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  font-size: 1rem;
  height: 10px;
  margin: 0 4px;
  width: 10px;
}
.flicking-pagination-bullet-active {
  background-color: #ff8989;
}
.flicking-arrow-next,
.flicking-arrow-prev {
  cursor: pointer;
  height: 64px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  z-index: 2;
  background-color: #2f2f2f80;
  border-radius: 55px;
  scale: 0.7;
}
.flicking-arrow-next:after,
.flicking-arrow-next:before,
.flicking-arrow-prev:after,
.flicking-arrow-prev:before {
  background-color: #ffffff !important;
  content: "";
  height: 6px;
  position: absolute;
  width: 24px;
}

.flicking-arrow-prev.is-outside {
  left: -40px !important;
  z-index: 3;
}
.flicking-arrow-next.is-outside {
  right: -40px !important;
  z-index: 3;
}
.citySelectWebApp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.cityList {
  max-height: 40vh;
  width: 100%;
  position: absolute;
  top: 110%;
  right: 0;
  background-color: #fbfbfb;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  overflow-y: auto;
  padding: 2%;
  z-index: 5;
}
.cityList::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.cityList::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 8px;
}

.cityList::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

.cityList p {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 10px;
  margin-left: 15px;
}
.cityList ul {
  padding-left: 0;
  list-style-type: none;
}
.cityList ul li {
  color: black;
  cursor: pointer;
  user-select: none;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.selectCityBlock {
  background-color: #fbfbfb;
  border-radius: 10px;
  padding: 1.5rem;
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.selectCityBlockHead p {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 3%;
}
.selectCityBlockBody {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
.selectCityInput {
  background-color: #fbfbfb;
  border-radius: 10px;
  padding: 10px;
  width: 100%;
  border: 1px solid #2f2f2f;
  outline: none;
  font-size: 18px;
  color: #333333;
  cursor: pointer;
}
.reservationButton {
  background-color: #2f2f2f;
  border-radius: 10px;
  border: 1px solid #2f2f2f;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 600;
  color: #ffffff;
  padding: 10px;
  cursor: pointer;
}
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap");
</style>
